import React from 'react';
import PropTypes from 'prop-types';
import { Container, Button } from 'react-bootstrap';

/**
 * Error boundary for lazy-loaded route components.
 * Catches chunk load errors and displays a retry UI.
 *
 * Uses a class component because React error boundaries require
 * getDerivedStateFromError / componentDidCatch lifecycle methods.
 */
class LazyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container className="text-center mt-5">
          <h4>Something went wrong loading this page.</h4>
          <p className="text-muted mb-3">Please check your connection and try again.</p>
          <Button variant="primary" onClick={this.handleRetry}>
            Retry
          </Button>
        </Container>
      );
    }
    return this.props.children;
  }
}

LazyErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LazyErrorBoundary;
